import { ApplicableChartTimeUnits } from '../../../pages/project/shared/project-detail-types';

export class ProjectProgressChartModel {
  public startDate: Date;
  public endDate: Date;
  public viewMode: ApplicableChartTimeUnits;
}
